import { ReactElement, cloneElement, useEffect } from 'react';

import { Grid, Link } from '@breathelife/mui';

import { ButtonVariantContainer, SmallActionButton, TextContainer, WidgetContainer } from './Styles';
import { ReactHtmlParser } from '@breathelife/ui-components';

type Props = {
  promptText: string;
  linkText: string;
  onAnswerChange: (answer: any, triggerStepNavigation?: boolean) => void;
  icon?: JSX.Element;
  resetOnMount?: boolean;
  boldedBorder?: boolean;
  variant?: 'link' | 'button';
  disabled?: boolean;
};

export function ActionButton(props: Props): ReactElement {
  // TODO: This is a hack. The intent is to reset the answer to false if the component is mounted.
  // This is needed because this component has no option for the user to "de-select" it. When going through a step with
  // this component, the underlying answer should be set to false, and only set to true if the user explicitly clicks this button.
  // TODO: A better solution would be to support the notion of auto-reset fields in the engine.
  useEffect(() => {
    if (props.resetOnMount) {
      props.onAnswerChange(false, false);
    }
  }, [props]);

  const content = (
    <Grid container spacing={1}>
      {props.icon && <Grid item>{cloneElement(props.icon, { size: '20px' })}</Grid>}
      <Grid item>
        <ReactHtmlParser html={props.linkText} />
      </Grid>
    </Grid>
  );

  if (props.variant === 'button') {
    return (
      <ButtonVariantContainer>
        <TextContainer>
          {props.promptText}
          <SmallActionButton type='button' disabled={props.disabled} onClick={() => props.onAnswerChange(true)}>
            {content}
          </SmallActionButton>
        </TextContainer>
      </ButtonVariantContainer>
    );
  }

  return (
    <WidgetContainer>
      <TextContainer>
        {props.promptText}
        <Link component='button' type='button' disabled={props.disabled} onClick={() => props.onAnswerChange(true)}>
          {content}
        </Link>
      </TextContainer>
    </WidgetContainer>
  );
}
